import { CognitoIdentityProviderClient, RevokeTokenCommand } from '@aws-sdk/client-cognito-identity-provider';

export const revokeCognitoToken = async (refreshToken: string): Promise<void> => {
    const region = process?.env?.REACT_APP_AWS_HOME_REGION || 'us-east-1';
    const client = new CognitoIdentityProviderClient({
        region,
    });

    const input = {
        Token: refreshToken,
        ClientId: process.env.REACT_APP_AWS_COGNITO_USERPOOL_CLIENTID,
    };

    const command = new RevokeTokenCommand(input);
    await client.send(command);
};
